import * as sdk from './lib/sdk'
// import * as sdk from 'pns-sdk'

export default sdk
